module.exports = __webpack_public_path__ + "img/material-blue-800.96af19a7.jpg";